import script from "./artmisadsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./artmisadsModal.vue?vue&type=script&setup=true&lang=js"

import "./artmisadsModal.vue?vue&type=style&index=0&id=f9917ad4&lang=less"

const __exports__ = script;

export default __exports__